/**
 * TutorReleaseSlotsScreen — « Libérer des créneaux » (route `tutor/liberer-creneaux`).
 *
 * Ouvert depuis « Ma dispo » (une heure avec live, `slot`), ou depuis le parcours d'absence d'un live
 * (`liveSessionId`, et `oneOffLabel` pour un essai ou un stage). Un fil : le brouillon, le
 * view-model, la lecture de la semaine, les gestes, la page du DS et la boîte d'un envoi refusé.
 */
import React from "react"
import { useSelector } from "react-redux"

import { TutorReleaseSlotsPage } from "../../../../../../design-system/tutor"
import { tutorReleaseSlotsViewModel } from "../../../../view-models/tutor/Availability/tutorReleaseSlotsViewModel"
import { type TutorSpaceScreenProps } from "../tutorSpaceRouteTypes"
import { TutorSendErrorDialog } from "./TutorSendErrorDialog"
import { useTutorReleaseSlotsData } from "./useTutorReleaseSlotsData"
import { useTutorReleaseSlotsState, useTutorReleaseSlotsUi } from "./useTutorReleaseSlotsState"

export function TutorReleaseSlotsScreen({ route }: TutorSpaceScreenProps) {
    const params = {
        slot: route?.params?.slot ?? null,
        liveSessionId: route?.params?.liveSessionId ?? null,
        oneOffLabel: route?.params?.oneOffLabel ?? null,
    }
    const [ui, dispatchUi] = useTutorReleaseSlotsUi(params.slot)
    const vm = useSelector((state: unknown) =>
        tutorReleaseSlotsViewModel(state, {
            ...ui,
            oneOffLabel: params.liveSessionId != null ? params.oneOffLabel : null,
        })
    )
    const { retry } = useTutorReleaseSlotsData(params.liveSessionId, (key) => dispatchUi({ type: "PRESELECT", key }))
    const { errorMessage, onDismissError, ...gestures } = useTutorReleaseSlotsState(vm, ui, dispatchUi, params)

    return (
        <>
            <TutorReleaseSlotsPage
                step={ui.step}
                days={vm.days}
                preselectedLabel={vm.preselectedLabel}
                canContinue={vm.canContinue}
                preview={vm.preview}
                tutorFirstname={vm.tutorFirstname}
                loading={vm.loading}
                error={vm.error}
                onRetry={retry}
                {...gestures}
                testID="tutor-release-slots"
            />
            <TutorSendErrorDialog message={errorMessage} onDismiss={onDismissError} />
        </>
    )
}
